import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "bold space-v1 data-title" }
const _hoisted_2 = { class: "bold" }
const _hoisted_3 = { class: "space-v3 data-title" }
const _hoisted_4 = { class: "space-h2" }
const _hoisted_5 = { class: "datalist-large" }
const _hoisted_6 = { class: "bold" }
const _hoisted_7 = { class: "bold" }
const _hoisted_8 = { class: "cats-actions" }
const _hoisted_9 = { class: "cats-actions" }
const _hoisted_10 = { class: "row q-col-gutter-md q-pb-lg" }
const _hoisted_11 = { class: "breadcrumb-container" }
const _hoisted_12 = { class: "col-12" }
const _hoisted_13 = { class: "col-12" }
const _hoisted_14 = { class: "col-12" }
const _hoisted_15 = { class: "col-12" }
const _hoisted_16 = { class: "row q-col-gutter-md q-pb-lg justify-center q-mt-sm" }
const _hoisted_17 = { class: "row q-col-gutter-md" }
const _hoisted_18 = { class: "col-6" }
const _hoisted_19 = { class: "checkbox-container" }
const _hoisted_20 = { class: "row q-mt-lg" }
const _hoisted_21 = { class: "title" }
const _hoisted_22 = { style: {"margin-right":"0.5rem"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_product_search_modal = _resolveComponent("product-search-modal")!
  const _component_Label = _resolveComponent("Label")!
  const _component_q_toggle = _resolveComponent("q-toggle")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_spinner = _resolveComponent("spinner")!
  const _component_ChevronLeftIcon = _resolveComponent("ChevronLeftIcon")!
  const _component_d_button = _resolveComponent("d-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_product_information = _resolveComponent("product-information")!
  const _component_channel_information = _resolveComponent("channel-information")!
  const _component_stock_information = _resolveComponent("stock-information")!
  const _component_options_and_variants = _resolveComponent("options-and-variants")!
  const _component_trash_icon = _resolveComponent("trash-icon")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_close_icon = _resolveComponent("close-icon")!
  const _component_product_card = _resolveComponent("product-card")!
  const _component_PenIcon = _resolveComponent("PenIcon")!
  const _component_ChevronRightIcon = _resolveComponent("ChevronRightIcon")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_product_search_modal),
    _createElementVNode("div", {
      class: _normalizeClass(["cats-detected", {loading: _ctx.iceCatState.loading, show: _ctx.hasIceCatData, hide: _ctx.iceCatState.show === false}])
    }, [
      _createElementVNode("div", {
        class: "cats-dismiss t-icon",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.iceCatState.show = false))
      }, "j"),
      _createVNode(_component_q_dialog, {
        class: "cats-dialog",
        modelValue: _ctx.iceCatState.showDialog,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.iceCatState.showDialog) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card, null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.iceCatState.data.entries(), ([key, item]) => {
                return (_openBlock(), _createBlock(_component_q_card_section, null, {
                  default: _withCtx(() => [
                    _createElementVNode("h3", _hoisted_1, [
                      (key !== _ctx.productId)
                        ? (_openBlock(), _createBlock(_component_Label, {
                            key: 0,
                            value: "Component",
                            style: {"display":"inline-block","width":"auto !important","line-height":"1.6","border":"none !important","margin-right":"10px"}
                          }))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", _hoisted_2, _toDisplayString(key === _ctx.productId ? _ctx.product?.title : _ctx.components?.find(c => c.sys.id === key)?.title), 1)
                    ]),
                    _createElementVNode("h5", _hoisted_3, [
                      _cache[12] || (_cache[12] = _createElementVNode("span", { class: "bold" }, "EAN", -1)),
                      _createElementVNode("span", _hoisted_4, _toDisplayString(key === _ctx.productId ? _ctx.product?.ean?.toString() : _ctx.components?.find(c => c.sys.id === key)?.ean?.toString()), 1)
                    ]),
                    _createElementVNode("dl", _hoisted_5, [
                      _createElementVNode("dt", null, [
                        _createElementVNode("h4", _hoisted_6, [
                          _createVNode(_component_q_toggle, {
                            dense: "",
                            class: _normalizeClass({[`cats-data-toggle__general`]: true}),
                            "model-value": ['title', 'ean', 'description', 'variants'].every(t => _ctx.iceCatState.applyTo.get(key)?.includes(t)),
                            "onUpdate:modelValue": ($event: any) => (['title', 'ean', 'description', 'variants'].forEach(t => !$event ? _ctx.iceCatState.applyTo.get(key).splice(_ctx.iceCatState.applyTo.get(key).indexOf(t), 1) : _ctx.iceCatState.applyTo.get(key).push(t)))
                          }, null, 8, ["model-value", "onUpdate:modelValue"]),
                          _cache[13] || (_cache[13] = _createElementVNode("span", { class: "bold" }, "General", -1))
                        ])
                      ]),
                      _cache[17] || (_cache[17] = _createElementVNode("dd", null, null, -1)),
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['title', 'ean', 'description', 'variants'], (t) => {
                        return (_openBlock(), _createElementBlock(_Fragment, null, [
                          _createElementVNode("dt", null, [
                            _createVNode(_component_q_toggle, {
                              dense: "",
                              class: _normalizeClass({[`cats-data-toggle__${t}`]: true, hide: !item[t]?.length}),
                              "model-value": !!_ctx.iceCatState.applyTo.get(key)?.includes(t),
                              "onUpdate:modelValue": ($event: any) => (!$event ? _ctx.iceCatState.applyTo.get(key).splice(_ctx.iceCatState.applyTo.get(key).indexOf(t), 1) : _ctx.iceCatState.applyTo.get(key).push(t))
                            }, null, 8, ["class", "model-value", "onUpdate:modelValue"]),
                            _createElementVNode("span", null, _toDisplayString(_ctx.format.title(t)), 1)
                          ]),
                          _createElementVNode("dd", {
                            style: _normalizeStyle({opacity: !item[t]?.length ? '.5' : '1'})
                          }, _toDisplayString(!item[t]?.length ? 'Not available' : Array.isArray(item[t]) ? item[t].join(', ') : item[t]), 5)
                        ], 64))
                      }), 64)),
                      _createElementVNode("dt", null, [
                        _createElementVNode("h4", _hoisted_7, [
                          _createVNode(_component_q_toggle, {
                            dense: "",
                            class: _normalizeClass({[`cats-data-toggle__general`]: true}),
                            "model-value": ['brand', 'producer'].every(t => _ctx.iceCatState.applyTo.get(key)?.includes(t)),
                            "onUpdate:modelValue": ($event: any) => (['brand', 'producer'].forEach(t => !$event ? _ctx.iceCatState.applyTo.get(key).splice(_ctx.iceCatState.applyTo.get(key).indexOf(t), 1) : _ctx.iceCatState.applyTo.get(key).push(t)))
                          }, null, 8, ["model-value", "onUpdate:modelValue"]),
                          _cache[14] || (_cache[14] = _createElementVNode("span", { class: "bold" }, "Origin information", -1))
                        ])
                      ]),
                      _cache[18] || (_cache[18] = _createElementVNode("dd", null, null, -1)),
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['brand', 'producer'], (t) => {
                        return (_openBlock(), _createElementBlock(_Fragment, null, [
                          _createElementVNode("dt", null, [
                            _createVNode(_component_q_toggle, {
                              dense: "",
                              class: _normalizeClass({[`cats-data-toggle__${t}`]: true, hide: !item[t]?.length}),
                              "model-value": !!_ctx.iceCatState.applyTo.get(key)?.includes(t),
                              "onUpdate:modelValue": ($event: any) => (!$event ? _ctx.iceCatState.applyTo.get(key).splice(_ctx.iceCatState.applyTo.get(key).indexOf(t), 1) : _ctx.iceCatState.applyTo.get(key).push(t))
                            }, null, 8, ["class", "model-value", "onUpdate:modelValue"]),
                            _createElementVNode("span", null, _toDisplayString(_ctx.format.title(t)), 1)
                          ]),
                          _createElementVNode("dd", {
                            style: _normalizeStyle({opacity: !item[t]?.length ? '.5' : '1'})
                          }, _toDisplayString(!item[t]?.length ? 'Not available' : Array.isArray(item[t]) ? item[t].join(', ') : item[t]), 5)
                        ], 64))
                      }), 64)),
                      _cache[19] || (_cache[19] = _createElementVNode("dt", null, [
                        _createElementVNode("h5", { class: "bold" }, [
                          _createElementVNode("span", { class: "bold" }, "Dimensions & Weight")
                        ])
                      ], -1)),
                      _cache[20] || (_cache[20] = _createElementVNode("dd", null, null, -1)),
                      _createElementVNode("dt", null, [
                        _createVNode(_component_q_toggle, {
                          dense: "",
                          class: _normalizeClass({[`cats-data-toggle__${_ctx.t}`]: true, hide: !item.dimensions?.x}),
                          "model-value": !!_ctx.iceCatState.applyTo.get(key)?.includes('dimensions'),
                          "onUpdate:modelValue": ($event: any) => (!$event ? _ctx.iceCatState.applyTo.get(key).splice(_ctx.iceCatState.applyTo.get(key).indexOf('dimensions'), 1) : _ctx.iceCatState.applyTo.get(key).push('dimensions'))
                        }, null, 8, ["class", "model-value", "onUpdate:modelValue"]),
                        _cache[15] || (_cache[15] = _createElementVNode("span", null, "Dimensions", -1))
                      ]),
                      _createElementVNode("dd", {
                        style: _normalizeStyle({opacity: !item.dimensions?.x ? '.5' : '1'})
                      }, _toDisplayString(item.dimensions?.x ? `${item.dimensions.x} x ${item.dimensions.y} x ${item.dimensions.z}` : 'Not available'), 5),
                      _createElementVNode("dt", null, [
                        _createVNode(_component_q_toggle, {
                          dense: "",
                          class: _normalizeClass({[`cats-data-toggle__${_ctx.t}`]: true, hide: !item.weight}),
                          "model-value": !!_ctx.iceCatState.applyTo.get(key)?.includes('weight'),
                          "onUpdate:modelValue": ($event: any) => (!$event ? _ctx.iceCatState.applyTo.get(key).splice(_ctx.iceCatState.applyTo.get(key).indexOf('weight'), 1) : _ctx.iceCatState.applyTo.get(key).push('weight'))
                        }, null, 8, ["class", "model-value", "onUpdate:modelValue"]),
                        _cache[16] || (_cache[16] = _createElementVNode("span", null, "Weight", -1))
                      ]),
                      _createElementVNode("dd", {
                        style: _normalizeStyle({opacity: !item.weight ? '.5' : '1'})
                      }, _toDisplayString(item.weight || 'Not available'), 5)
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _withDirectives(_createVNode(_component_q_btn, {
                        class: "flat highlight fullwidth space-v2",
                        onClick: ($event: any) => (_ctx.enrichItem(key))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Apply to " + _toDisplayString(key === _ctx.productId ? 'Product' : 'Component'), 1)
                        ]),
                        _: 2
                      }, 1032, ["onClick"]), [
                        [_vShow, _ctx.iceCatState.applyTo.get(key)?.length]
                      ])
                    ])
                  ]),
                  _: 2
                }, 1024))
              }), 256))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createElementVNode("div", {
        class: _normalizeClass(["cats-loading", {show: _ctx.iceCatState.loading}])
      }, [
        _createVNode(_component_spinner, {
          scale: 0.3,
          visible: true,
          style: {"margin":"0 auto","width":"50px"}
        })
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(["cats-inner", {show: !_ctx.iceCatState.loading && _ctx.hasIceCatData}])
      }, [
        _cache[23] || (_cache[23] = _createElementVNode("h6", null, [
          _createElementVNode("span", { class: "bold" }, "Product found on "),
          _createElementVNode("span", {
            class: "bold underline has-tooltip",
            "data-tooltip": "Icecat is an open database with a wide range of products. Directify searches the Icecat database to find items matching your product(-component) EANs, allowing you to easily enrich your product information"
          }, "Icecat")
        ], -1)),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_q_btn, {
            class: "outline",
            flat: "",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.iceCatState.showDialog = true))
          }, {
            default: _withCtx(() => _cache[21] || (_cache[21] = [
              _createTextVNode("View")
            ])),
            _: 1
          }),
          _createVNode(_component_q_btn, {
            class: "highlight",
            flat: "",
            onClick: _cache[3] || (_cache[3] = e => _ctx.enrichItem())
          }, {
            default: _withCtx(() => _cache[22] || (_cache[22] = [
              _createTextVNode("Enrich")
            ])),
            _: 1
          })
        ])
      ], 2)
    ], 2),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        (_ctx.parentProduct)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: { name: 'ProductDetailIndex', params: { productId: _ctx.parentProduct.sys.id } }
            }, {
              default: _withCtx(({ href, navigate }) => [
                _createVNode(_component_d_button, { onClick: navigate }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ChevronLeftIcon, {
                      class: "q-mr-sm",
                      size: "16px"
                    }),
                    _cache[24] || (_cache[24] = _createElementVNode("span", null, "Back to parent", -1))
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 1
            }, 8, ["to"]))
          : (_ctx.channelRoute.route==='Channels')
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 1,
                to: { name: 'channels', params: {channelId: _ctx.channelRoute.channelId}}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ChevronLeftIcon, {
                    size: "16px",
                    style: {"margin":"-3px 6px 0 0"}
                  }),
                  _cache[25] || (_cache[25] = _createElementVNode("span", null, "Back to channels", -1))
                ]),
                _: 1
              }, 8, ["to"]))
            : (_openBlock(), _createBlock(_component_router_link, {
                key: 2,
                to: {name: 'ProductsOverview', query: _ctx.$route.query}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ChevronLeftIcon, {
                    size: "16px",
                    style: {"margin":"-3px 6px 0 0"}
                  }),
                  _cache[26] || (_cache[26] = _createElementVNode("span", null, "Back to search", -1))
                ]),
                _: 1
              }, 8, ["to"]))
      ]),
      _createElementVNode("div", _hoisted_12, [
        (_ctx.product || _ctx.isCreating)
          ? (_openBlock(), _createBlock(_component_product_information, {
              key: _ctx.productId,
              product: _ctx.isCreating ? _ctx.productDraft : _ctx.product,
              components: _ctx.components,
              creating: _ctx.isCreating,
              "onUpdate:product": _ctx.saveProduct
            }, null, 8, ["product", "components", "creating", "onUpdate:product"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_13, [
        (_ctx.product || _ctx.isCreating)
          ? (_openBlock(), _createBlock(_component_channel_information, {
              locked: _ctx.isCreating,
              product: _ctx.isCreating ? _ctx.productDraft : _ctx.product,
              key: _ctx.productId
            }, null, 8, ["locked", "product"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_14, [
        (!_ctx.loading)
          ? (_openBlock(), _createBlock(_component_stock_information, {
              locked: _ctx.isCreating,
              components: _ctx.components,
              "product-id": _ctx.productId,
              key: _ctx.productId,
              "prop-values": _ctx.optionsAndVariants?.propValues,
              "onUpdate:component": _ctx.saveComponent,
              "onUpdate:addComponents": _ctx.addProductComponents,
              "onUpdate:removeComponent": _ctx.removeProductComponent,
              onSaveOrder: _cache[4] || (_cache[4] = ($event: any) => (void _ctx.saveProduct(_ctx.productId, $event)))
            }, null, 8, ["locked", "components", "product-id", "prop-values", "onUpdate:component", "onUpdate:addComponents", "onUpdate:removeComponent"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_15, [
        ((_ctx.product || _ctx.isCreating) && !_ctx.loading)
          ? (_openBlock(), _createBlock(_component_options_and_variants, {
              locked: _ctx.isCreating,
              "all-props": _ctx.allProps,
              product: _ctx.product,
              key: _ctx.productId,
              "product-options": !_ctx.product ? null : _ctx.product.options,
              "product-components": !_ctx.product ? null : _ctx.product.components,
              "product-variants": !_ctx.product ? null : _ctx.product.variants,
              onSave: _ctx.saveProductOptionsAndVariants,
              ref: "optionsAndVariants"
            }, null, 8, ["locked", "all-props", "product", "product-options", "product-components", "product-variants", "onSave"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      (!_ctx.isCreating)
        ? (_openBlock(), _createBlock(_component_q_btn, {
            key: 0,
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showDeleteDialog = true)),
            color: "error",
            unelevated: "",
            rounded: "",
            outline: "",
            style: {"padding-bottom":"14px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_trash_icon, { left: "" }),
              _cache[27] || (_cache[27] = _createElementVNode("span", null, "Remove product", -1))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_q_dialog, {
        class: "delete-dialog",
        modelValue: _ctx.showDeleteDialog,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.showDeleteDialog) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card, {
            class: "q-pa-lg",
            style: {"max-width":"none"}
          }, {
            default: _withCtx(() => [
              _cache[31] || (_cache[31] = _createElementVNode("div", { class: "row q-col-gutter-md q-mb-md" }, [
                _createElementVNode("div", { class: "col-6" }, [
                  _createElementVNode("h3", null, "Before you delete the product...")
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_17, [
                _cache[28] || (_cache[28] = _createElementVNode("div", { class: "col-6" }, [
                  _createElementVNode("p", null, "The product will be deleted but it may have connected data. Select which data connected to the product you want to delete.")
                ], -1)),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_q_checkbox, {
                      modelValue: _ctx.deleteCascade.catalogue_products,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.deleteCascade.catalogue_products) = $event)),
                      label: "Channel links",
                      size: "lg",
                      dense: ""
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_q_checkbox, {
                      modelValue: _ctx.deleteCascade.stock_items,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.deleteCascade.stock_items) = $event)),
                      label: "Stock items",
                      size: "lg",
                      dense: ""
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_q_checkbox, {
                      modelValue: _ctx.deleteCascade.variants,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.deleteCascade.variants) = $event)),
                      label: "Variants",
                      size: "lg",
                      dense: ""
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_q_btn, {
                  class: "delete-btn",
                  onClick: _ctx.onDelete,
                  unelevated: "",
                  rounded: "",
                  color: "error"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, [
                      _createVNode(_component_trash_icon)
                    ]),
                    _cache[29] || (_cache[29] = _createElementVNode("span", { style: {"margin-left":"0.5rem"} }, "Delete product", -1))
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_q_btn, {
                  class: "cancel-btn",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showDeleteDialog = false)),
                  flat: "",
                  rounded: "",
                  unelevated: ""
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, [
                      _createVNode(_component_close_icon)
                    ]),
                    _cache[30] || (_cache[30] = _createElementVNode("span", { style: {"margin-left":"0.5rem"} }, "Cancel", -1))
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createVNode(_component_q_dialog, {
      class: "duplicate-product",
      modelValue: _ctx.showDuplicateDialog,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.showDuplicateDialog) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createElementVNode("h5", _hoisted_21, "A product with this " + _toDisplayString(_ctx.duplicateValue) + " already exists", 1),
                _createElementVNode("p", null, "If you edit the existing product, the recently created product will be deleted. However, if you continue with this new product the " + _toDisplayString(_ctx.duplicateValue) + " code in the existing product will be deleted.", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, { class: "flex" }, {
              default: _withCtx(() => [
                (_ctx.duplicateProduct)
                  ? (_openBlock(), _createBlock(_component_product_card, {
                      key: 0,
                      product: _ctx.duplicateProduct
                    }, null, 8, ["product"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_btn, {
                  class: "btn primary",
                  onClick: _ctx.editDuplicateProduct,
                  flat: "",
                  rounded: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_PenIcon, { size: "22px" }),
                    _cache[32] || (_cache[32] = _createElementVNode("span", { style: {"margin-left":"0.5rem"} }, "Existing product", -1))
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                  class: "btn secondary",
                  onClick: _ctx.editCurrentProduct,
                  flat: "",
                  rounded: ""
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_22, "Use different " + _toDisplayString(_ctx.duplicateValue), 1),
                    _createVNode(_component_ChevronRightIcon, { size: "22px" })
                  ]),
                  _: 1
                }, 8, ["onClick"])), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}